import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import * as playlistReducers from "../../reducers/playlist";
import * as pageReducers from "../../reducers/pages";
import * as playlistActions from "../../actions/playlist";
import {withRouter} from 'react-router';


import ListItem from "../common/listItem";
import FilterBar from "../common/FilterBar";
import VigItem from "./VigItem";
import * as vignetsReducers from "../../reducers/vignets";
import * as vignetsActions from "../../actions/vignets";
import ReactImageFallback from "react-image-fallback";

import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import {Input, Modal, ModalBody} from 'reactstrap';
import {Link} from "react-router-dom";
import UploadFile from '../includes/UploadFile';
import * as userActions from "../../actions/user";
import NewPlaylist from "./NewPlaylist";

import Loader from 'react-loader-spinner';
// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
};

const grid = 8;

const getItemStyle = (isDragging, draggableStyle) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: 'none',
    padding: grid * 2,
    margin: `0 0 ${grid}px 0`,

    // change background colour if dragging
    background: isDragging ? 'transperent' : 'white',

    // styles we need to apply on draggables
    ...draggableStyle,
});

const getListStyle = isDraggingOver => ({
    background: isDraggingOver ? 'white' : 'white',
    padding: grid,
    width: "auto",
    clear:"both",
    display:"inline-block"
});


class PlaylistContainer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            value: '',
            userDet : JSON.parse(window.localStorage.userDet),
            modal: false,
            wrapClass : 'Playlist-container ',
            items : undefined,
            image_path: null,
            playlistName: "",
            playlistDesc:""
        };

        this.onDragEnd = this.onDragEnd.bind(this);
        this.showVignetsList = this.showVignetsList.bind(this);
        this.forceUpdatePlaylist = this.forceUpdatePlaylist.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.showEditModal = this.showEditModal.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    getUploadedFile(fileName) {
        console.log(fileName);
        this.setState({
            image_path: fileName
        });
        console.log(this.state.image_path+"========= thi.state.iamgepath");
    }
    componentDidMount() {

        let data = { userid : this.state.userDet.user_id};
        this.props.allPlaylistData(data);
        this.props.allVignetsData(data);

        console.log("showplaylist"+ this.props.showPlaylist); console.log("showVignets"+ this.props.showVignets);
        this.setState(
            {
                showPlaylist: this.props.showPlaylist,
                showVignets: this.props.showVignets,
                plnameClass: 'playlist-side-header inactive',
                showPlNameSave : false,
                nameUpdated : false

            }
        );

    }

    shouldComponentUpdate(nextProps, nextState){

        if(this.props !== nextProps  || this.state !== nextState) {
            return true;
        }
    }


    componentDidUpdate(prevProps, prevState, snapshot) {
        // Typical usage (don't forget to compare props):

        if (this.props.playlistData.playListItems !== prevProps.playlistData.playListItems) {
            this.setState(
                {
                    showPlaylist: this.props.showPlaylist,
                    showVignets: this.props.showVignets,
                    showEdit: this.props.showEdit

                }
            );
        }

        /*if (this.props.playlistData.playListDetail !== prevProps.playlistData.playListDetail) {
            console.log(this.props.playlistData.playListDetail[0].pl_name);
            this.setState({
                    playlist_name: this.props.playlistData.playListDetail? this.props.playlistData.playListDetail[0].pl_name :'',
                    items:this.props.playlistData.playListDetail

                },
                () => {
                    console.log(this.state.playlist_name);
                    console.log(this.props.playlistData.playListDetail);
                });

        }*/

        console.log(this.state.nameUpdated+"===="+prevState.nameUpdated+"===="+this.state.showPlaylist+"===="+prevState.showPlaylist);

        if(this.props.playlistData.playlistCreated !== prevProps.playlistData.playlistCreated ||  ( this.state.nameUpdated === true && this.state.showPlaylist !== prevState.showPlaylist)) {
            this.forceUpdatePlaylist();
        }

        if(this.props.playlistData.playlistUpdated !== prevProps.playlistData.playlistUpdated ) {
            this.showEditPlaylist(this.props.playlistData.playlistId);
        }


    }

    handleInputChange(event) {
        this.setState({
            [event.target.name]: event.target.value
        });
    }
    handleSubmit(e) {
        console.log(this.state);
        //e.preventDefault();
        let formInvalid = 0;

        //Name validation

        if( this.state.playlistName === '') {
            formInvalid++;
            document.getElementsByName('playlistName')[0].classList.add('is-invalid');
        };

        //* Desc validation
        if( this.state.playlistDesc === '') {
            formInvalid++;
            document.getElementsByName('playlistDesc')[0].classList.add('is-invalid');
        };



        if( formInvalid === 0) {

            var playlistData = { plName: this.state.playlistName, plDesc : this.state.playlistDesc, user_id : this.state.userDet.user_id , vigIds:'', plImage : this.state.image_path, plId :''};
            console.log(playlistData);
            let playlistCreated = this.props.createPlaylist(playlistData);
            console.log(playlistCreated);
            //this.props.forceUpdateHandler();
            this.mToggle();


        }

    }
    forceUpdatePlaylist(){
        console.log("force");
        let data = {userid : this.state.userDet.user_id};
        this.props.allPlaylistData(data);
    }

    showVignetsList() {

        this.props.newPlaylist();
        this.setState(
            {
                showPlaylist: false,
                showVignets: true,
                showEdit: false,
                wrapClass:'',
                nameUpdated : false

            }
        );
    }

    hideVignetsList() {
        this.props.hideCreatePlaylist();
        this.setState(
            {
                showPlaylist: true,
                showVignets: false,
                showEdit: false
            }
        );


    }

    showEditPlaylist(plId) {

        console.log("showEdit");
        let data = {"plId" : plId};
        this.props.getPlaylist(data);

        this.setState(
            {
                showPlaylist: false,
                showVignets: true,
                showEdit:true,
                wrapClass:'split-panel',
                nameUpdated : false
            }
        );

        //this.setState({playlist_name: this.props.playlistData.playListDetail? this.props.playlistData.playListDetail[0].name:''});

    }

    removeFromPlaylist(vignetId) {
        let data = {plid : this.props.playlistData.playlistId, vigid :vignetId}
        this.props.removeFromPlaylist(data);
    }

    editPlName() {
        this.setState(
            {
                plnameClass: 'playlist-side-header ',
                showPlNameSave : true

            }
        );
    }

    savePlName() {
        let data = {plname : this.state.playlist_name, plid :this.props.playlistData.playlistId, userid : this.state.userDet.user_id}
        this.props.savePlaylistName(data);
        this.setState(
            {
                plnameClass: 'playlist-side-header inactive',
                showPlNameSave : false,
                nameUpdated : true

            }
        );

    }

    onDragEnd(result) {
        // dropped outside the list
        if (!result.destination) {
            return;
        }

        const items = reorder(
            this.props.playlistData.playListDetail,
            result.source.index,
            result.destination.index
        );

        console.log(result.source.index);
        console.log(result.destination.index);

        this.props.sortPlaylist({plItems: items, plId : this.props.playlistData.playlistId});


        this.setState({
            items,
        });
    }

    showDetailPopup(playlist) {

        console.log("showEdit");

        console.log(playlist);

        this.setState(
            {
                showPop: true,
                playlist : playlist
            },
            () => {
                console.log(this.state.showDetailPop);
                console.log(this.state.vignet);
            });

        //this.setState({playlist_name: this.props.playlistData.playListDetail? this.props.playlistData.playListDetail[0].name:''});

    }

    showEditModal() {
        this.props.newPlaylist();
       this.props.showPlaylistModal();
    }



    render() {

        let playListData = (this.props.playlistData.searchText || this.props.playlistData.sort) ? this.props.playlistData.filteredData :  this.props.playlistData.playListItems;
        let vignetsList = this.props.vignetsData.vignetsList;

        let playlist = this.state.playlist;

        console.log(this.props.vignetsData);

        var protocol = window.location.protocol;
        var slashes = protocol.concat("//");
        var host = slashes.concat(window.location.host);

        let baseUrl = host+'/#';

        return (

            <div className={this.state.wrapClass}>

                {this.state.showPlaylist &&
                <div className="collection-container">

                    {!playListData &&
                    <div className="loaderWrapper">
                        <Loader type="ThreeDots" color="#23ada6"  height="50" width="50"/>
                    </div>
                    }

                    <div className="panel-block new-panel" onClick={this.showEditModal}>

                        <div className="gallery-thumb">
                            <div className="new-button-block">
                                <button className="icon-lib add-button"></button>
                                <p>Add Playlist</p>
                            </div>
                        </div>

                    </div>

                    {playListData && playListData.length > 0 &&

                    playListData.map((entry, index) => <ListItem detail={entry} showEditPlaylist={this.showEditPlaylist.bind(this)} showDetailPopup={this.showDetailPopup.bind(this)} itemType="playlist"/>
                    )
                    }
                    {playListData && playListData.length == 0 &&

                    <div>No Playlist Added</div>
                    }
                </div>
                }

                {this.state.showEdit &&


                <div className="playlist-side-panel" >

                    <div className={this.state.plnameClass}>
                        <input type="text" name="playlist_name" id="playlist_name" className="header-input" placeholder="Playlist Name"  onChange={(e) => {this.handleInputChange(e)}} value={this.state.playlist_name} />

                        {this.state.showPlNameSave &&
                        <button className="input-option save " onClick={(e) => { this.savePlName(e) }}></button>
                        }
                        {!this.state.showPlNameSave &&
                            <button className="input-option modify" onClick={(e) => { this.editPlName(e) }}></button>
                        }
                    </div>

                    <DragDropContext onDragEnd={this.onDragEnd}>
                        <Droppable droppableId="droppable">
                            {(provided, snapshot) => (
                                <div className="added-block"
                                    ref={provided.innerRef}
                                    style={getListStyle(snapshot.isDraggingOver)}
                                >
                                    {this.state.items &&
                                    this.state.items.map((entry, index) => (
                                        <Draggable key={entry.le_id} draggableId={entry.le_id} index={index}>
                                            {(provided, snapshot) => (
                                                <div className="ind-added"
                                                    ref={provided.innerRef}
                                                    {...provided.draggableProps}
                                                    {...provided.dragHandleProps}
                                                    style={getItemStyle(
                                                        snapshot.isDragging,
                                                        provided.draggableProps.style
                                                    )}
                                                >

                                                    <div>
                                                        <div className="header-text-added">
                                                            <div className="added-thumb">
                                                                <ReactImageFallback
                                                                    src={entry.imgSrc}
                                                                    fallbackImage={entry.defImgSrc}
                                                                    initialImage={entry.defImgSrc}
                                                                    alt="cool image should be here"
                                                                    className="my-image" />
                                                            </div>
                                                            <p>{entry.vignet_title}</p>
                                                        </div>
                                                        <button className="remover-button" title="Remove" onClick={() => {this.removeFromPlaylist(entry.vignet_id)}}></button>
                                                    </div>
                                                </div>
                                            )}
                                        </Draggable>
                                    ))}


                                    {provided.placeholder}
                                </div>
                            )}
                        </Droppable>
                    </DragDropContext>

                </div>
                }

                {this.state.showVignets &&

                <div className="playlist-right-panel" id="right-vig-block">
                    <div className="back-to-list">
                        <button className="filter-btn back-ico" onClick={()=>this.hideVignetsList()}>Back to Listing</button>
                    </div>

                    <div className="ind-playlist-container">

                        {vignetsList &&
                        vignetsList.map((entry, index) =>
                            !this.props.playlistData.vignetIds.includes(entry.vignet_id) &&
                            <VigItem detail={entry}/>
                        )
                        }


                    </div>
                </div>
                }

                {this.state.playlist &&



                <div className="">
                    <Modal isOpen={this.state.showPop} toggle={this.mToggle} centered={true} className="vig-mod modal-lg vig-modal">

                        <ModalBody className="fixed-scroll">
                            <button type="button" className="close md-close" data-dismiss="modal" onClick={this.mToggle}></button>
                            <div className="modal-content-wrapper">
                                <div className="modal-content-left">
                                    <div className="vignet-file-img"><ReactImageFallback
                                        src={playlist.imgSrc}
                                        fallbackImage={playlist.defImgSrc}
                                        initialImage={playlist.defImgSrc}
                                        alt="cool image should be here"
                                        className="my-image"/></div>
                                    <ul className="vignet-file-option">
                                        <li className="file-option-click"><a href="javascript:;" onClick={(e) => {this.showEditPlaylist(e,playlist.pl_id)}} data-id={playlist.pl_id}>Edit</a>
                                        </li>
                                        <li className="file-option-click"><Link to={`/listVignets/${playlist.pl_id}`}>View</Link>
                                        </li>
                                    </ul>
                                </div>
                                <div className="modal-content-right">
                                    <div className="vignet-file-header">
                                        <div className="vignet-file-header-left">
                                            <h5>{playlist.pl_name}</h5>
                                        </div>
                                    </div>
                                    <div className="vig-file-st">
                                        <div className="ind-vig-file">
                                            <div className="file-ico"><span className="stand-bg red"></span> <span
                                                className="view-ico"></span></div>
                                            <div className="file-info-wrap">
                                                <div className="file-info"><span className="stand-num">0</span> <span
                                                    className="view-text">Total Views</span></div>
                                            </div>
                                        </div>
                                        <div className="ind-vig-file">
                                            <div className="file-ico"><span className="stand-bg green"></span> <span
                                                className="vig-ico"></span></div>
                                            <div className="file-info-wrap">
                                                <div className="file-info"><span className="stand-num">{playlist.vignetCount}</span> <span
                                                    className="view-text">Total Vignets</span></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="playlist-form-area">

                                        <div className="input-block">
                                            <input className="input-box" placeholder="Enter URL" name="playlistUrl" value={baseUrl + playlist.playlistUrl} disabled />
                                                <span className="url-ic"></span>
                                        </div>
                                        <div className="input-block">
                                            <input className="input-box" placeholder="Enter Mail ID" name="emailIds" value={playlist.emailIds} />
                                                <span className="mail-ic"></span>
                                        </div>
                                        <div className="text-block">
                                            <textarea className="textarea" placeholder="Enter Description" name="message" value={playlist.message}></textarea>
                                        </div>
                                        <div className="playlist-form-button">
                                            <button className="gen-button">Save</button>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </ModalBody>
                    </Modal>
                </div>
                }

                <NewPlaylist />
            </div>


        );
    }
}

PlaylistContainer.propTypes = {
    showPlaylist: PropTypes.bool,
    showVignets : PropTypes.bool
}

function mapStateToProps(state) {
    return {
        playlistData  :playlistReducers.getPlaylistData(state),
        pageInfo  : pageReducers.getPageSettings(state),
        vignetsData  :vignetsReducers.getVignetsData(state)
    };

}
export default  withRouter(connect(mapStateToProps, {
    allPlaylistData : playlistActions.getPlayLists,
    allFilteredData : playlistActions.searchPlaylists,
    allVignetsData : vignetsActions.fetchVignetsData,
    getPlaylist : playlistActions.getPlayListDetails,
    removeFromPlaylist : playlistActions.removeFromPlaylist,
    savePlaylistName :  playlistActions.savePlaylistName,
    newPlaylist:playlistActions.newPlaylist,
    hideCreatePlaylist:playlistActions.hideCreatePlaylist,
    sortPlaylist: playlistActions.sortPlaylist,
    createPlaylist : playlistActions.createPlaylist,
    showPlaylistModal : playlistActions.showPlaylistModal
})(PlaylistContainer, FilterBar));




// WEBPACK FOOTER //
// ./src/components/playlist/PlaylistContainer.js